import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Col, Form, Row, DatePicker, Select, Transfer, Card, Tooltip, message, Modal } from 'antd';
import Input from '../../ui/Input';
import TextArea from '../../ui/TextArea';
import { SearchOutlined } from '@ant-design/icons';
import { LocalPersistence } from '../../../factories';
import { updateRecreation, deleteRecreation } from '../../../services/recreation'
import { getOTACodes } from '../../../services/common'
import './index.scss'
import Loading from '../../Loading';
import PageContainer from '../../CSIComponents/PageContainer';
import moment from 'moment';
import ActionButtonsBar from '../../ui/ActionButtonsBar'
import { PROXIMITY_OPTIONS } from '@constants/index'
import { isTagsDisplayed } from '@helpers/FeatureFlags'
const { Option } = Select;

const Edit = (props: any) => {
    const [form] = Form.useForm();
    const [transferData, setTransferData] = useState<Array<any>>([])
    const [transferTargetKeys, setTransferTargetKeys] = useState<Array<any>>([props.tableCurrentData.tags && props.tableCurrentData.tags != '' ? props.tableCurrentData.tags.split(" | ") : []])
    const [addLoading, setAddLoading] = useState(false)
    const [data, setData] = useState<Array<any>>([])
    const [typeList, setTypeList] = useState<Array<any>>([]);
    const [disabledStatus, setDisabledStatus] = useState(false)

    useEffect(() => {
        getTransferData()
        getTypeList()
        props.tableCurrentData.tags && props.tableCurrentData.tags != '' ? setTransferTargetKeys(props.tableCurrentData.tags.split(' | ')) : setTransferTargetKeys([])
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])
    // get transfer
    const getTransferData = async () => {
        // setAddLoading(true)
        let res = await getOTACodes('TAG', '')
        // setAddLoading(false)
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setTransferData(res.otacodes)
            setData(res.otacodes)
        } else {
            setTransferData([])
        }
    };
    const getTypeList = async () => {
        // setAddLoading(true)
        let res = await getOTACodes('RST', '')
        // setAddLoading(false)
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setTypeList(res.otacodes)
        } else {
            setTypeList([])
        }
    }
    const onSearchChange = (e: any) => {
        let res = data.filter(item => item.codeName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1)
        setTransferData(res)
    }
    const validateFieldsError = (changedValues: any, allValues: any) => {
        form.validateFields().then(() => {
            setDisabledStatus(false)

        }).catch(() => {
            let savelock = false
            let s = form?.getFieldsError()
            for (let i = 0; i < s.length; i++) {
                if (s[i].errors.length) {
                    savelock = true;
                    break
                }
            }
            setDisabledStatus(savelock)
        })
    }
    const handleChange = (targetKeys: any) => {
        setTransferTargetKeys(targetKeys)
    };

    const addSave = () => {

        form.validateFields().then(async (value) => {
            const get_session = new LocalPersistence('session')
            const session: any = await get_session.getSessionPersistence()
            value.tags = transferTargetKeys.length != 0 ? transferTargetKeys.join(' | ') : ''
            const params = {
                "supplier": session.supplier,
                "propertyId": session.propertyId,
                "property": {
                    "recreations": [
                        {
                            "name": value.name,
                            "id": value.id,
                            "type": value.type,
                            "typedetail": value.typedetail,
                            "proximity": value.proximity,
                            'included': value.included,
                            "quanity": value.quanity == undefined ? "" : value.quanity,
                            "includedinroomorate": value.included == undefined ? "" : value.included,
                            "distance": value.distance == undefined ? "" : value.distance,
                            'yearquipreplaced': value.yearquipreplaced == undefined ? "" : value.yearquipreplaced.format('YYYY'),
                            //'yearquipreplaced': value.yearquipreplaced,
                            'description': value.description,
                            "tags": value.tags,
                            "recreationid": props.tableCurrentData.recreationid,
                            "recreationlangid": props.tableCurrentData.recreationlangid
                        }
                    ]
                }
            }
            setAddLoading(true)
            updateRecreation(params).then(res => {
                setAddLoading(false)
                if (res.result.success) {
                    setAddLoading(false)
                    props.resetDetailInfo(params.property.recreations[0])
                    props.handelCancelBtnClick();
                } else {
                    message.error({
                        content: res?.error[0]?.message || 'operation failed'
                    });
                }
            }, err => {
                setAddLoading(false)
                message.error({
                    content: err.message || err.error[0].message
                });
            })
        })
    }
    const handlCancelClick = () => {
        props.handelCancelBtnClick();
    }
    const ModalHead = () => {
        return (
            <div style={{
                position: 'absolute',
                left: 0,
                top: 0,
                height: '50px',
                lineHeight: '50px',
                textIndent: '10px',
                borderBottom: '1px solid #ccc',
                color: '#fff',
                background: '#06789D',
                fontSize: 18,
                width: '100%'
            }}>Confirm</div>
        )
    }
    const DeleteClick = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        let bodeData = {
            "supplier": session.supplier,
            "propertyId": session.propertyId,
            "property": {
                "recreations": [
                    {
                        "recreationid": props.tableCurrentData.recreationid,
                        "recreationlangid": props.tableCurrentData.recreationlangid
                    }
                ]
            }
        }
        Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content: `Are you sure you want to delete this record?`,
            cancelText: 'Cancel',
            okText: 'Delete',
            onOk() {
                setAddLoading(true)
                deleteRecreation(bodeData).then(res => {
                    setAddLoading(false)
                    if (res.result.success) {
                        props.deleteJupm()
                    } else {
                        message.error({
                            content: res?.error[0]?.message || 'operation failed'
                        });
                    }
                }, err => {
                    setAddLoading(false)
                    message.error({
                        content: err.message || err.error[0].message
                    });
                })
            },
            onCancel() {

            },
        });

    }

    if (addLoading) return <Loading type="large" />
    return (
      <PageContainer>
        <Card style={{ marginBottom: '60px' }}>
          <Grid container spacing={0} className='containerSpacing py-0'>
            <Grid item xs={12} className='pb-0 px-0 my-0'>
              <Form
                layout='vertical'
                form={form}
                name='basic'
                initialValues={{
                  ...props.tableCurrentData,
                  yearquipreplaced: props.tableCurrentData.yearquipreplaced
                    ? moment(props.tableCurrentData.yearquipreplaced)
                    : null,
                }}
                onValuesChange={validateFieldsError}>
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      label='Name'
                      name='name'
                      rules={[
                        {
                          max: 64,
                          message:
                            'You have reached the max character length of 64',
                        },
                      ]}>
                      <Input maxLength={64} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label='Recreation ID'
                      name='id'
                      rules={[
                        {
                          max: 16,
                          message:
                            'You have reached the max character length of 16',
                        },
                      ]}>
                      <Input maxLength={16} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name='type'
                      label='Type'
                      rules={[
                        { required: true, message: 'This field is required' },
                      ]}>
                      <Select allowClear showSearch>
                        {typeList.length > 0 &&
                          typeList.map((item: any, index: any) => {
                            return (
                              <Option key={index} value={item.codeName}>
                                {item.codeName}
                              </Option>
                            )
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}></Col>

                  <Col span={12}>
                    <Form.Item
                      label='Type Detail'
                      name='typedetail'
                      help="Lanyon 30 characters"
                      rules={[
                        {
                          max: 128,
                          message:
                            'You have reached the max character length of 128',
                        },
                      ]}>
                      <Input maxLength={128} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label='Proximity'
                      name='proximity'
                      rules={[
                        { required: true, message: 'This field is required' },
                      ]}>
                      <Select allowClear defaultValue="" showSearch>
                        {Object.values(PROXIMITY_OPTIONS).map(
                          (item: string, index: number) => (
                            <Option key={index} value={item}>
                              {item}
                            </Option>
                          ),
                        )}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}></Col>

                  <Col span={6}>
                    <Form.Item
                      name='included'
                      label='Included'
                      rules={[
                        { required: true, message: 'This field is required' },
                      ]}>
                      <Select allowClear showSearch>
                        <Option value='Yes'>Yes</Option>
                        <Option value='No'>No</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label='Quantity'
                      name='quanity'
                      rules={[
                        {
                          required: false,
                          pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                          message: 'This field should be a number',
                        },
                      ]}>
                      <Input type='number' />
                    </Form.Item>
                  </Col>
                  <Col span={12}></Col>
                  <Col span={6}>
                    <Form.Item
                      label='Distance'
                      name='distance'
                      rules={[
                        {
                          required: false,
                          pattern: /^\d*(\.\d*)?$/,
                          message: 'This field should be a number',
                        },
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label='Year Equipment Replaced'
                      name='yearquipreplaced'
                    >
                      <DatePicker picker='year' />
                    </Form.Item>
                  </Col>
                  <Col span={12}></Col>

                  <Col span={18}>
                    <Form.Item
                      label='Description'
                      name='description'
                      rules={[
                        {
                          max: 1000,
                          message:
                            'You have reached the max character length of 1000',
                        },
                      ]}>
                      <TextArea maxLength={1000} rows={3} />
                    </Form.Item>
                  </Col>
                  <Col span={6}></Col>

                  { isTagsDisplayed &&
                    <Col span={18}>
                      <Form.Item name='tags' label='Selected Tags'>
                        <Input
                          onChange={onSearchChange}
                          style={{ width: '300px' }}
                          suffix={
                            <Tooltip title='search'>
                              <SearchOutlined
                                style={{ color: 'rgba(0,0,0,.45)' }}
                              />
                            </Tooltip>
                          }
                        />
                        <Transfer
                          dataSource={transferData}
                          targetKeys={transferTargetKeys}
                          onChange={handleChange}
                          render={(item) => item.codeName}
                        />
                      </Form.Item>
                    </Col>
                  }
                  <Col span={6}></Col>
                </Row>
              </Form>
            </Grid>
          </Grid>
        </Card>
        <ActionButtonsBar
          onDelete={DeleteClick}
          onCancel={handlCancelClick}
          onSave={addSave}
          disabledSave={disabledStatus}
          warningMsg={true}
        />
      </PageContainer>
    )
}
export default Edit;
